// extracted by mini-css-extract-plugin
module.exports = {"features":"Features_features__alyQK","features__main":"Features_features__main__iOyNj","features__tablet":"Features_features__tablet__MngSO"};